import React from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import {CardContainer, Input, Button} from 'components/common/uiKit'
import Avatar from 'components/common/app/avatar';
import {Language} from 'components/common/app';

import {getUser, setUser, logout} from 'services/user';
import {AvatarAction} from 'services/redux/actions';
import {serverUrl} from 'services/network';

class Account extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mobile: '',
            name: ''
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        const user = getUser();
        if (user)
            this.setState({mobile: user.mobile, name: user.fullName});
    }

    _handleLogout = () => {
        logout();
    };

    _avatarChangeCallback = (data) => {
        const avatar = serverUrl + data.avatar;

        const {actions} = this.props;
        actions.setAvatar(avatar);

        let userStorage = getUser();
        userStorage.avatar = avatar;
        setUser(userStorage);
    };

    render() {
        const {mobile, name} = this.state;

        const {locale, avatar} = this.props;
        const pageTranslates = locale.translation.Pages.App.Account;

        return (
            <>
                <CardContainer>
                    <h3>
                        {pageTranslates.Title}
                    </h3>
                    <div style={{display: 'flex', justifyContent: 'center'}} className='mt-3'>
                        <Avatar src={avatar} editAllow size='large' onChange={this._avatarChangeCallback.bind(this)}/>
                    </div>
                    <div className='mt-3'>
                        <Input placeholder={pageTranslates.Mobile} value={mobile} disabled icon='phone'/>
                        <Input placeholder={pageTranslates.FullName} value={name} disabled icon='user'/>
                    </div>
                    <div className='mt-3'>
                        <Button type='secondary' full onClick={this._handleLogout}>
                            <i className='fa fa-power-off'></i>
                            <span className='pr-2 pl-2'>
                                {pageTranslates.SignOut}
                            </span>
                        </Button>
                    </div>
                </CardContainer>
                <CardContainer>
                    <Language/>
                </CardContainer>
            </>
        );
    }
}

const ActionCreators = Object.assign({}, AvatarAction);

const mapDispatchToProps = dispatch => {
    return ({
        actions: bindActionCreators(ActionCreators, dispatch)
    });
};

const mapStateToProps = state => {
    const {locale, avatar} = state;
    return {locale, avatar};
};

export default connect(mapStateToProps, mapDispatchToProps)(Account);



